<template>
  <div>
    adress management
  </div>
</template>

<script>
export default {
  components: {
  },

  data() {
    return {
    };
  },
  methods: {
  },
};
</script>



<style lang="scss" scoped>

</style>
